export const worldLevelInfos = [
    {
        worldLevel: 0,
        leyLineMora: 12000,
        leyLineXp: 25000,
        ascensionMaterialDrop: {
            bossMaterial : 1.63,
            stone1: 2.12
        }
    },
    {
        worldLevel: 1,
        leyLineMora: 20000,
        leyLineXp: 38500,
        ascensionMaterialDrop: {
            bossMaterial: 1.71,
            stone1: 2.13
        }
    },
    {
        worldLevel: 2,
        leyLineMora: 28000,
        leyLineXp: 52500,
        ascensionMaterialDrop: {
            bossMaterial: 1.75,
            stone1: 1.16,
            stone2: 1.28
        }
    },
    {
        worldLevel: 3,
        leyLineMora: 36000,
        leyLineXp: 67500,
        ascensionMaterialDrop: {
            bossMaterial: 1.91,
            stone1: 1.19,
            stone2: 1.37
        }
    },
    {
        worldLevel: 4,
        leyLineMora: 45000,
        leyLineXp: 82500,
        ascensionMaterialDrop: {
            bossMaterial: 2.03,
            stone1: 1.49,
            stone2: 1.43,
            stone3: 0.11

        }
    },
    {
        worldLevel: 5,
        leyLineMora: 52000,
        leyLineXp: 102500,
        ascensionMaterialDrop: {
            bossMaterial : 2.22,
            stone1: 1.74,
            stone2: 1.44,
            stone3: 0.11
        }
    },
    {
        worldLevel: 6,
        leyLineMora: 60000,
        leyLineXp: 122500,
        ascensionMaterialDrop: {
            bossMaterial: 2.37,
            stone1: 1.93,
            stone2: 1.55,
            stone3: 0.12,
            stone4: 0.014
        }
    },
    {
        worldLevel: 7,
        leyLineMora: 60000,
        leyLineXp: 122500,
        ascensionMaterialDrop: {
            bossMaterial: 2.55,
            stone1: 2.15,
            stone2: 1.61,
            stone3: 0.13,
            stone4: 0.020
        }
    },
    {
        worldLevel: 8,
        leyLineMora: 60000,
        leyLineXp: 122500,
        ascensionMaterialDrop: {
            bossMaterial : 2.58,
            stone1: 2.12,
            stone2: 1.60,
            stone3: 0.16,
            stone4: 0.013
        }
    },]